import { render, staticRenderFns } from "./capsule-text.vue?vue&type=template&id=5aff3722&scoped=true"
import script from "./capsule-text.vue?vue&type=script&lang=ts"
export * from "./capsule-text.vue?vue&type=script&lang=ts"
import style0 from "./capsule-text.vue?vue&type=style&index=0&id=5aff3722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff3722",
  null
  
)

export default component.exports